import DataStore from './dataStore'

class _SceneDataStore extends DataStore {
}

export const SceneDataStore = new _SceneDataStore()
